import { createUseStyles } from 'react-jss';

import { IProgressType } from './types';

const useStyles = createUseStyles<string, { type: IProgressType }>(
  {
    '@keyframes slide': {
      from: {
        marginLeft: '-45%',
      },
      to: {
        marginLeft: '100%',
      },
    },
    root: {
      backgroundColor: '#e0e0e0',
      overflow: 'hidden',
      position: 'relative',
      height: ({ type }) => (type === 'thin' ? 4 : 6),
    },
    bar: {
      animation: '1.5s ease-in 0s infinite running $slide',
      background: 'linear-gradient(90deg, var(--x-accent-1-1) 42.64%, #D8A5D7 100%)',
      height: '100%',
      position: 'absolute',
      width: '40%',
      top: 0,
      left: 0,
    },
  },
  { name: 'indeterminate-progress' },
);

export default useStyles;
